import React from 'react';
import styled from 'styled-components';

import { primaryColor, greyDark } from '~theme';

const FeedbackGrader = ({ value, setValue }) => (
  <Wrapper>
    <Grades>
      {[...Array(11).keys()].map(g => (
        <Grade key={g} active={g === value} onClick={() => setValue(g)}>
          {g}
        </Grade>
      ))}
    </Grades>
    <Legend>
      <div>0 = hyvin epätodennäköisesti</div>
      <div>10 = hyvin todennäköisesti</div>
    </Legend>
  </Wrapper>
);

const Wrapper = styled.div`
  font-size: 16px;
`;

const Grades = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    margin-bottom: 12px;
  }
`;

const Grade = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  font-weight: bold;
  font-size: 22px;

  width: 38px;
  height: 38px;
  gap: 12px;

  border: 1px solid #ced4da; // Bootstrap field border color
  border-radius: 100%;
  background-color: ${props => (props.active ? primaryColor : 'white')};
  color: ${props => (props.active ? 'white' : primaryColor)};

  cursor: pointer;

  @media (max-width: 768px) {
    font-size: 16px;
    width: 26px;
    height: 26px;
  }
`;

const Legend = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: center;
  color: #313131;

  font-size: 12px;
`;

export default FeedbackGrader;
